import { Link } from "react-router-dom";

const CrmService = () => {
  return (
    <>
      <section className="crm-service-section bg-white ptb-120">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-xl-6 col-lg-7">
              <div className="crm-title text-center">
                <span className="crm-subtitle">
                  Our Services
                  <img
                    src="assets/img/shape/arrow-red.png"
                    alt="arrow"
                    className="ms-2"
                  />
                </span>
                <h2 className="mt-1 mb-3">What Do You Need Help?</h2>
                <p className="mb-0">
                  Bring in quality leads, nurture them, and turn them into
                  happy, paying customers. you've had with them, and more—all in
                  a single place.
                </p>
              </div>
            </div>
          </div>
          <div className="mt-5">
            <div className="row g-4 justify-content-center">
              <div className="col-xl-4 col-md-6">
                <div className="crm-service-box rounded">
                  <span className="icon-wrapper d-flex align-items-center justify-content-center rounded">
                    <svg
                      width="26"
                      height="26"
                      viewBox="0 0 26 26"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M23.4564 0.847656H2.54282C1.1403 0.847656 -0.000732422 1.98869 -0.000732422 3.39121V22.6091C-0.000732422 24.0117 1.1403 25.1527 2.54282 25.1527H23.4564C24.859 25.1527 26 24.0117 26 22.6091V3.39121C26 1.98869 24.859 0.847656 23.4564 0.847656ZM6.78205 23.457H2.54282C2.07531 23.457 1.69495 23.0766 1.69495 22.6091V9.32613H6.78205V23.457ZM24.3043 22.6091C24.3043 23.0766 23.9239 23.457 23.4564 23.457H8.47779V9.32613H24.3043V22.6091ZM24.3043 7.63044H1.69495V3.39121C1.69495 2.9237 2.07531 2.54334 2.54282 2.54334H23.4564C23.9239 2.54334 24.3043 2.9237 24.3043 3.39121V7.63044V7.63044Z"
                        fill="#EF3D3D"
                      />
                      <path
                        d="M4.23849 5.93475C4.70676 5.93475 5.08636 5.55515 5.08636 5.08688C5.08636 4.61862 4.70676 4.23901 4.23849 4.23901C3.77023 4.23901 3.39062 4.61862 3.39062 5.08688C3.39062 5.55515 3.77023 5.93475 4.23849 5.93475Z"
                        fill="#EF3D3D"
                      />
                      <path
                        d="M7.62985 5.93475C8.09811 5.93475 8.47772 5.55515 8.47772 5.08688C8.47772 4.61862 8.09811 4.23901 7.62985 4.23901C7.16159 4.23901 6.78198 4.61862 6.78198 5.08688C6.78198 5.55515 7.16159 5.93475 7.62985 5.93475Z"
                        fill="#EF3D3D"
                      />
                      <path
                        d="M11.0211 5.93475C11.4894 5.93475 11.869 5.55515 11.869 5.08688C11.869 4.61862 11.4894 4.23901 11.0211 4.23901C10.5529 4.23901 10.1733 4.61862 10.1733 5.08688C10.1733 5.55515 10.5529 5.93475 11.0211 5.93475Z"
                        fill="#EF3D3D"
                      />
                      <path
                        d="M21.7606 13.0001H11.0211C10.5529 13.0001 10.1733 13.3797 10.1733 13.848C10.1733 14.3162 10.5529 14.6959 11.0211 14.6959H21.7606C22.2288 14.6959 22.6084 14.3163 22.6084 13.848C22.6084 13.3798 22.2288 13.0001 21.7606 13.0001Z"
                        fill="#EF3D3D"
                      />
                      <path
                        d="M21.7606 17.9971H11.0211C10.5529 17.9971 10.1733 18.3767 10.1733 18.8449C10.1733 19.3132 10.5529 19.6928 11.0211 19.6928H21.7606C22.2288 19.6928 22.6084 19.3132 22.6084 18.8449C22.6084 18.3767 22.2288 17.9971 21.7606 17.9971Z"
                        fill="#EF3D3D"
                      />
                    </svg>
                  </span>
                  <h5 className="mb-2 mt-4">CRM Plus</h5>
                  <p className="mb-4">
                    Bring in quality leads, nurture them, and turn them and
                    more—all in a single place.
                  </p>
                  <Link href="/services" className="read-more-link">
                    Explore More{" "}
                    <i className="fa-solid fa-arrow-right-long ms-1"></i>
                  </Link>
                </div>
              </div>
              <div className="col-xl-4 col-md-6">
                <div className="crm-service-box rounded">
                  <span className="icon-wrapper d-flex align-items-center justify-content-center rounded">
                    <svg
                      width="35"
                      height="34"
                      viewBox="0 0 35 34"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M23.0002 21.8566C22.1337 21.8566 21.4287 21.2816 21.4287 20.575C21.4287 19.8683 22.1337 19.2934 23.0002 19.2934C23.8667 19.2934 24.5716 19.8683 24.5716 20.575C24.5716 20.9467 24.8914 21.2481 25.2859 21.2481C25.6803 21.2481 26.0002 20.9467 26.0002 20.575C26.0002 19.3416 25.0249 18.3046 23.7144 18.0231V17.6731C23.7144 17.3014 23.3946 17 23.0002 17C22.6057 17 22.2859 17.3014 22.2859 17.6731V18.0231C20.9754 18.3046 20.0002 19.3416 20.0002 20.575C20.0002 22.0239 21.3459 23.2027 23.0002 23.2027C23.8667 23.2027 24.5716 23.7776 24.5716 24.4843C24.5716 25.191 23.8667 25.7659 23.0002 25.7659C22.1337 25.7659 21.4287 25.191 21.4287 24.4843C21.4287 24.1126 21.1089 23.8112 20.7144 23.8112C20.32 23.8112 20.0002 24.1126 20.0002 24.4843C20.0002 25.7177 20.9754 26.7547 22.2859 27.0362V27.3269C22.2859 27.6986 22.6057 28 23.0002 28C23.3946 28 23.7144 27.6986 23.7144 27.3269V27.0362C25.0249 26.7547 26.0002 25.7177 26.0002 24.4843C26.0002 23.0353 24.6544 21.8566 23.0002 21.8566Z"
                        fill="#EF3D3D"
                      />
                      <path
                        d="M26.0322 11.5689C25.9504 11.3741 25.8502 11.1904 25.7336 11.0201H27.483C29.1873 11.0201 30.574 9.63342 30.574 7.92907C30.574 6.22473 29.1873 4.83808 27.483 4.83808H22.102C22.444 4.3407 22.6449 3.73896 22.6449 3.09099C22.6449 1.38665 21.2582 0 19.5539 0H3.09099C1.38665 0 0 1.38665 0 3.09099C0 4.79534 1.38665 6.18199 3.09099 6.18199H8.47201C8.12992 6.67937 7.92907 7.28111 7.92907 7.92907C7.92907 8.57704 8.12985 9.17878 8.47201 9.67616H6.71955C5.01521 9.67616 3.62856 11.0628 3.62856 12.7672C3.62856 13.746 4.08643 14.6195 4.79877 15.1862C4.08643 15.7529 3.62856 16.6264 3.62856 17.6052C3.62856 18.5841 4.08643 19.4575 4.79877 20.0243C4.08643 20.591 3.62856 21.4645 3.62856 22.4433C3.62856 23.4221 4.08643 24.2956 4.79877 24.8623C4.08643 25.4291 3.62856 26.3025 3.62856 27.2814C3.62856 28.9857 5.01521 30.3724 6.71955 30.3724H14.6385C16.7247 32.6037 19.6925 34.001 22.9809 34.001C29.2797 34.001 34.4042 28.8765 34.4042 22.5778C34.4042 17.3354 30.8542 12.9071 26.0322 11.5689ZM27.483 6.18199C28.4464 6.18199 29.2301 6.96576 29.2301 7.92907C29.2301 8.89239 28.4464 9.67616 27.483 9.67616H23.1825H11.0201C10.0567 9.67616 9.27298 8.89239 9.27298 7.92907C9.27298 6.96576 10.0567 6.18199 11.0201 6.18199H27.483ZM3.09099 4.83808C2.12761 4.83808 1.34391 4.05431 1.34391 3.09099C1.34391 2.12768 2.12761 1.34391 3.09099 1.34391H19.5539C20.5173 1.34391 21.301 2.12768 21.301 3.09099C21.301 4.05431 20.5173 4.83808 19.5539 4.83808H3.09099ZM6.71955 11.0201H23.1825C23.4531 11.0201 23.7123 11.083 23.9448 11.1956C23.627 11.1689 23.3056 11.1545 22.9809 11.1545C19.8264 11.1545 16.9666 12.4399 14.8974 14.5142H6.71955C5.75624 14.5142 4.97247 13.7305 4.97247 12.7672C4.97247 11.8038 5.75624 11.0201 6.71955 11.0201ZM6.71955 15.8581H13.7492C12.9864 16.9032 12.3966 18.082 12.0221 19.3523H6.71955C5.75617 19.3523 4.97247 18.5686 4.97247 17.6052C4.97247 16.6419 5.75617 15.8581 6.71955 15.8581ZM6.71955 20.6962H11.7135C11.6116 21.3086 11.5577 21.9369 11.5577 22.5778C11.5577 23.1251 11.5973 23.6634 11.6721 24.1904H6.71955C5.75617 24.1904 4.97247 23.4067 4.97247 22.4433C4.97247 21.4799 5.75617 20.6962 6.71955 20.6962ZM6.71955 29.0285C5.75617 29.0285 4.97247 28.2448 4.97247 27.2814C4.97247 26.318 5.75617 25.5343 6.71955 25.5343H11.9464C12.2855 26.7985 12.8363 27.9766 13.5586 29.0285H6.71955ZM22.9809 32.6571C17.4232 32.6571 12.9016 28.1355 12.9016 22.5778C12.9016 17.02 17.4232 12.4984 22.9809 12.4984C28.5387 12.4984 33.0603 17.02 33.0603 22.5778C33.0603 28.1355 28.5387 32.6571 22.9809 32.6571Z"
                        fill="#EF3D3D"
                      />
                    </svg>
                  </span>
                  <h5 className="mb-2 mt-4">Finance Plus</h5>
                  <p className="mb-4">
                    Bring in quality leads, nurture them, and turn them and
                    more—all in a single place.
                  </p>
                  <Link href="/services" className="read-more-link">
                    Explore More{" "}
                    <i className="fa-solid fa-arrow-right-long ms-1"></i>
                  </Link>
                </div>
              </div>
              <div className="col-xl-4 col-md-6">
                <div className="crm-service-box rounded">
                  <span className="icon-wrapper d-flex align-items-center justify-content-center rounded">
                    <svg
                      width="26"
                      height="26"
                      viewBox="0 0 26 26"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M23.4564 0.847656H2.54282C1.1403 0.847656 -0.000732422 1.98869 -0.000732422 3.39121V22.6091C-0.000732422 24.0117 1.1403 25.1527 2.54282 25.1527H23.4564C24.859 25.1527 26 24.0117 26 22.6091V3.39121C26 1.98869 24.859 0.847656 23.4564 0.847656ZM6.78205 23.457H2.54282C2.07531 23.457 1.69495 23.0766 1.69495 22.6091V9.32613H6.78205V23.457ZM24.3043 22.6091C24.3043 23.0766 23.9239 23.457 23.4564 23.457H8.47779V9.32613H24.3043V22.6091ZM24.3043 7.63044H1.69495V3.39121C1.69495 2.9237 2.07531 2.54334 2.54282 2.54334H23.4564C23.9239 2.54334 24.3043 2.9237 24.3043 3.39121V7.63044V7.63044Z"
                        fill="#EF3D3D"
                      />
                      <path
                        d="M4.23849 5.93475C4.70676 5.93475 5.08636 5.55515 5.08636 5.08688C5.08636 4.61862 4.70676 4.23901 4.23849 4.23901C3.77023 4.23901 3.39062 4.61862 3.39062 5.08688C3.39062 5.55515 3.77023 5.93475 4.23849 5.93475Z"
                        fill="#EF3D3D"
                      />
                      <path
                        d="M7.62985 5.93475C8.09811 5.93475 8.47772 5.55515 8.47772 5.08688C8.47772 4.61862 8.09811 4.23901 7.62985 4.23901C7.16159 4.23901 6.78198 4.61862 6.78198 5.08688C6.78198 5.55515 7.16159 5.93475 7.62985 5.93475Z"
                        fill="#EF3D3D"
                      />
                      <path
                        d="M11.0211 5.93475C11.4894 5.93475 11.869 5.55515 11.869 5.08688C11.869 4.61862 11.4894 4.23901 11.0211 4.23901C10.5529 4.23901 10.1733 4.61862 10.1733 5.08688C10.1733 5.55515 10.5529 5.93475 11.0211 5.93475Z"
                        fill="#EF3D3D"
                      />
                      <path
                        d="M21.7606 13.0001H11.0211C10.5529 13.0001 10.1733 13.3797 10.1733 13.848C10.1733 14.3162 10.5529 14.6959 11.0211 14.6959H21.7606C22.2288 14.6959 22.6084 14.3163 22.6084 13.848C22.6084 13.3798 22.2288 13.0001 21.7606 13.0001Z"
                        fill="#EF3D3D"
                      />
                      <path
                        d="M21.7606 17.9971H11.0211C10.5529 17.9971 10.1733 18.3767 10.1733 18.8449C10.1733 19.3132 10.5529 19.6928 11.0211 19.6928H21.7606C22.2288 19.6928 22.6084 19.3132 22.6084 18.8449C22.6084 18.3767 22.2288 17.9971 21.7606 17.9971Z"
                        fill="#EF3D3D"
                      />
                    </svg>
                  </span>
                  <h5 className="mb-2 mt-4">Marketing Plus</h5>
                  <p className="mb-4">
                    Bring in quality leads, nurture them, and turn them and
                    more—all in a single place.
                  </p>
                  <Link href="/services" className="read-more-link">
                    Explore More{" "}
                    <i className="fa-solid fa-arrow-right-long ms-1"></i>
                  </Link>
                </div>
              </div>
            </div>
            <p className="text-center crm-explore-text mt-40">
              Do You Want To explore More Bundle{" "}
              <a href="#" className="text-decoration-underline fw-bold">
                Just Click Here
              </a>
            </p>
          </div>
        </div>
      </section>
    </>
  );
};

export default CrmService;
